module.exports = __webpack_public_path__ + "static/media/phone.de6928a8.svg";